import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { PreAuthPermissionGate } from '../../components/PreAuthPermissionGate';
import { AllowedProvider, allowedConnectOptionsSchema } from '../../constants/common';

const searchParamsSchema = z.object({
  port: z.coerce.number(),
  authUrl: z.string(),
});

export const Route = createFileRoute('/auth/$provider/pre-auth')({
  validateSearch: searchParamsSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ params: { provider }, deps: { port, authUrl } }) => {
    // Validate provider
    const providerResult = allowedConnectOptionsSchema.safeParse(provider);

    if (!providerResult.success) {
      throw redirect({
        to: '/auth/$provider/error',
        params: { provider },
        search: { reason: `Invalid provider: ${providerResult.error.issues.map((issue) => issue.message).join(', ')}` },
      });
    }

    // Validate that both params are provided
    if (!port || !authUrl) {
      throw redirect({
        to: '/auth/$provider/error',
        params: { provider },
        search: { reason: 'Missing port or authUrl' },
      });
    }

    return { port, authUrl, provider: providerResult.data };
  },
  component: PreAuth,
});

function PreAuth() {
  const { port, authUrl, provider } = Route.useLoaderData();

  return <PreAuthPermissionGate port={port} authUrl={authUrl} provider={provider as AllowedProvider} />;
}
